import * as z from "zod/v4";
import type { util } from "zod/v4/core";

function _createEnum<const T extends readonly string[]>(
  values: T,
  params?: z.core.$ZodEnumParams & { enumName?: string },
): z.ZodEnum<util.ToEnum<T[number]>>;
function _createEnum<const T extends util.EnumLike>(
  values: T,
  params?: z.core.$ZodEnumParams & { enumName?: string },
): z.ZodEnum<T>;
function _createEnum<const T extends readonly string[]>(
  values: T,
  params?: z.core.$ZodEnumParams & { enumName?: string },
): z.ZodEnum<util.ToEnum<T[number]>> {
  const schema = z.enum(values, {
    // Don't need to print expected values, included in another part of the error message
    error: (iss) => {
      const input = iss.input === "" ? "<empty-string>" : String(iss.input);
      return `Received ${input}`;
    },
    ...params,
  });

  if (params?.enumName) {
    return schema.meta({ name: params.enumName });
  }

  return schema;
}

export const createEnum = _createEnum;
